import { apiService } from './ApiService';
import { Video } from '../types';

// Tipagem para o formulário (pode ser parcial do Video)
export interface VideoFormData {
    title: string;
    description: string;
    url: string;
    level: string;
    duration?: string;
    icon?: string;
}

export interface YouTubeMetadata {
    title: string;
    description: string;
    thumbnailUrl: string;
    duration: string;
    embedUrl: string;
}

export class VideoService {
    private readonly baseUrl = '/videos';

    async getAll(filters: { level?: string; category?: string; page?: number; limit?: number } = {}): Promise<Video[]> {
        const params: any = {};
        if (filters.level && filters.level !== 'todos') params.level = filters.level;
        if (filters.category) params.category = filters.category;
        if (filters.page) params.page = filters.page;
        if (filters.limit) params.limit = filters.limit;

        return await apiService.get<Video[]>(this.baseUrl, { params });
    }

    async getById(id: number): Promise<Video> {
        return await apiService.get<Video>(`${this.baseUrl}/${id}`);
    }

    async create(video: Partial<VideoFormData>): Promise<Video> {
        return await apiService.post<Video>(this.baseUrl, video);
    }

    async update(id: number, video: Partial<VideoFormData>): Promise<Video> {
        return await apiService.put<Video>(`${this.baseUrl}/${id}`, video);
    }

    async delete(id: number): Promise<void> {
        return await apiService.delete(`${this.baseUrl}/${id}`);
    }

    async getLevels(): Promise<string[]> {
        return await apiService.get<string[]>(`${this.baseUrl}/levels`);
    }

    async getCategories(): Promise<string[]> {
        return await apiService.get<string[]>(`${this.baseUrl}/categories`);
    }

    /**
     * Busca metadados do YouTube através do endpoint backend existente
     */
    async fetchYouTubeMetadata(url: string): Promise<YouTubeMetadata | null> {
        try {
            // O backend espera ?url=...
            return await apiService.get<YouTubeMetadata>('/youtube/metadata', {
                params: { url }
            });
        } catch (error) {
            console.error('Erro ao buscar metadados do YouTube:', error);
            return null;
        }
    }
}

export const videoService = new VideoService();